import { Outlet } from 'react-router-dom';
import { Footer } from './components/footer';
import { Header } from './components/header';

export function Layout() {
    return (
        <div className="absolute z-20 flex flex-col justify-center items-center h-svh w-screen select-none">
            <Header />
            <div className="flex-2 w-full flex flex-col items-center overflow-y-scroll">
                <Outlet />
            </div>
            <Footer />
        </div>
    );
}
